export function useContractGroups() {
    onMounted(async () => {
        await load()
    })

    const load = async () => {
        await supplierStore.loadContractGroups()
    }

    const contractGroups = computed(() => supplierStore.contractGroups)

    return {contractGroups}
}
